import React, { useState } from 'react';
import styled from 'styled-components';

const CardContainer = styled.div`
  background: white;
  border-radius: 15px;
  padding: 1.5rem;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: ${props => props.categoryColor || '#667eea'};
  }
`;

const CategoryInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  font-size: 0.9rem;
  color: #666;
`;

const CategoryIcon = styled.span`
  font-size: 1.2rem;
`;

const TextContent = styled.p`
  font-size: 1.1rem;
  line-height: 1.6;
  color: #333;
  margin-bottom: 1rem;
  word-break: break-all;
`;

const ActionsBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
`;

const ActionButton = styled.button`
  background: none;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  padding: 0.5rem 1rem;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.3rem;
  
  &:hover {
    background: ${props => props.hoverColor || '#f5f5f5'};
    border-color: ${props => props.hoverColor || '#d0d0d0'};
  }
  
  &.active {
    background: ${props => props.activeColor || '#667eea'};
    color: white;
    border-color: ${props => props.activeColor || '#667eea'};
  }
`;

const CopyButton = styled(ActionButton)`
  &.copied {
    background: #4CAF50;
    color: white;
    border-color: #4CAF50;
  }
`;

const RecommendationTag = styled.span`
  position: absolute;
  top: 10px;
  right: 10px;
  background: linear-gradient(45deg, #FF6B6B, #4ECDC4);
  color: white;
  padding: 0.3rem 0.6rem;
  border-radius: 10px;
  font-size: 0.7rem;
  font-weight: bold;
`;

const TextCard = ({
  text,
  category,
  onToggleFavorite,
  isFavorite,
  recommendation
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      // 降级处理
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: '拍一拍文字',
          text: text,
          url: window.location.href,
        });
      } catch (err) {
        console.log('分享取消');
      }
    } else {
      // 降级到复制
      handleCopy();
    }
  };

  return (
    <CardContainer className="text-card fade-in" categoryColor={category?.color}>
      {recommendation && (
        <RecommendationTag>{recommendation}</RecommendationTag>
      )}

      <CategoryInfo>
        <CategoryIcon>{category?.icon}</CategoryIcon>
        <span>{category?.name}</span>
      </CategoryInfo>

      <TextContent>{text}</TextContent>

      <ActionsBar>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <CopyButton
            onClick={handleCopy}
            className={copied ? 'copied' : ''}
          >
            {copied ? '✓ 已复制' : '📋 复制'}
          </CopyButton>

          <ActionButton onClick={handleShare}>
            📤 分享
          </ActionButton>
        </div>

        <ActionButton
          onClick={onToggleFavorite}
          className={isFavorite ? 'active' : ''}
          activeColor="#FF6B6B"
          hoverColor="#ffebee"
        >
          {isFavorite ? '❤️ 已收藏' : '🤍 收藏'}
        </ActionButton>
      </ActionsBar>
    </CardContainer>
  );
};

export default TextCard;
